import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import CompoundInterestCalculator from '../../components/CompoundInterestCalculator';

const CompoundInterestCalc: React.FC = () => (
  <ToolLayout
    title="Compound Interest Calculator - Investment Growth | AllTools"
    description="Calculate compound interest and investment growth over time. Free financial calculator."
    canonicalPath="/compound-interest-calculator"
  >
    <CompoundInterestCalculator />
  </ToolLayout>
);

export default CompoundInterestCalc;
